import * as React from 'react';
import { Translate } from 'react-localize-redux';

import { DateChip, DateWrapper } from '../components';

interface DatepickerMonthsProps {
  className?: string;
  currentMonth: number;
  isDark?: boolean;
  onChange: (month: number) => void;
}

export const DatepickerMonths: React.FC<DatepickerMonthsProps> = (props) => {
  const Months = [
    {
      id: 0,
      value: 'january',
      label: 'DATEPICKER.MONTHS.JANUARY.SHORT',
    },
    {
      id: 1,
      value: 'february',
      label: 'DATEPICKER.MONTHS.FEBRUARY.SHORT',
    },
    {
      id: 2,
      value: 'march',
      label: 'DATEPICKER.MONTHS.MARCH.SHORT',
    },
    {
      id: 3,
      value: 'april',
      label: 'DATEPICKER.MONTHS.APRIL.SHORT',
    },
    {
      id: 4,
      value: 'may',
      label: 'DATEPICKER.MONTHS.MAY.SHORT',
    },
    {
      id: 5,
      value: 'june',
      label: 'DATEPICKER.MONTHS.JUNE.SHORT',
    },
    {
      id: 6,
      value: 'july',
      label: 'DATEPICKER.MONTHS.JULY.SHORT',
    },
    {
      id: 7,
      value: 'august',
      label: 'DATEPICKER.MONTHS.AUGUST.SHORT',
    },
    {
      id: 8,
      value: 'september',
      label: 'DATEPICKER.MONTHS.SEPTEMBER.SHORT',
    },
    {
      id: 9,
      value: 'october',
      label: 'DATEPICKER.MONTHS.OCTOBER.SHORT',
    },
    {
      id: 10,
      value: 'november',
      label: 'DATEPICKER.MONTHS.NOVEMBER.SHORT',
    },
    {
      id: 11,
      value: 'december',
      label: 'DATEPICKER.MONTHS.DECEMBER.SHORT',
    },
  ];

  return (
    <DateWrapper className={props.className}>
      {Months.map((month) => (
        <DateChip
          className={`${props.isDark ? 'dark' : ''} ${
            month.id === props.currentMonth ? 'active' : ''
          }`}
          key={month.value}
          weight="700"
          onClick={(ev) => {
            props.onChange(month.id);
            ev.stopPropagation();
          }}
        >
          <Translate id={month.label} />
        </DateChip>
      ))}
    </DateWrapper>
  );
};

export default DatepickerMonths;
